<template>
  <div>
    <h4>Bilder</h4>
      <div class="card p-3">
      <b-spinner v-if="inProgress"></b-spinner>
      <div class="d-inline-block" v-else>
        <b-card-group deck>
<!--          <b-row>-->
<!--            <draggable v-model="productImages" @change="sortImages">-->
<!--              <transition-group>-->
<!--                <ProductThumbnail-->
<!--                    v-for="image in productImages"-->
<!--                    :key="image.id"-->
<!--                    :image="image"-->
<!--                    v-on:image-deleted="reloadImages"-->
<!--                    :product-id="productId"-->
<!--                    :alt-text="altDefault"-->
<!--                    class="float-left mb-2 pa-0">-->

<!--                </ProductThumbnail>-->
<!--              </transition-group>-->
<!--            </draggable>-->
<!--          </b-row>-->
            <ProductThumbnail
                v-for="image in productImages"
                :key="image.id"
                :image="image"
                v-on:image-deleted="reloadImages"
                :product-id="productId"
                :alt-text="altDefault"
                class="float-left mb-2 pa-0">

            </ProductThumbnail>
        </b-card-group>
      </div>
      <ImageUpload @image-uploaded="reloadImages" :alt-text="altDefault" :productId="productId" class="w-100"></ImageUpload>
    </div>
  </div>
</template>

<script>

import products from "@/api/products";
import ProductThumbnail from "@/pages/EditProductPage/ProductThumbnail";
import ImageUpload from "@/pages/EditProductPage/ImageUpload";
// import draggable from 'vuedraggable';

export default {
  props: ['images', 'altDefault'],
  data() {
    return {
      productImages: this.images,
      inProgress: false,
    }
  },
  components: {
    ProductThumbnail,
    ImageUpload,
    // draggable
  },
  computed: {
    productId () {
      return this.$route.params.id
    }
  },
  methods: {
    reloadImages(){
      this.inProgress = true;
      products.getProduct(this.productId).then(product => {
        this.productImages = product.images;
        this.inProgress=false;
      })
    },
    sortImages(){
        this.productImages.map((e, idx) => {
            return products.putImage(this.productId, {
                id: e.id,
                position: idx + 1
            })
        })

    }
  }
}
</script>
